import Carousel from './CustomCarousel'
import { t } from 'i18next'
import { Item } from '../../../../../store/types'
import { Typography } from '@mui/material'
import i18n from '../../../../../config/i18n'
import { environment } from '../../../../../enviroments/enviroment'


const translationBase = 'components.infoSidebar.schedule.carousel.history'
const urlBase = `${environment.publicUrl}/assets/image/carousel/info/history`

const LIGHT_PL_1 = `${urlBase}/history-light-PL-1.png`
const DARK_PL_1 = `${urlBase}/history-dark-PL-1.png`
const LIGHT_EN_1 = `${urlBase}/history-light-EN-1.png`
const DARK_EN_1 = `${urlBase}/history-dark-EN-1.png`

const HistoryCarousel = () => {
  const isPolish = i18n.language === 'pl'
  const items: Item[] = [
    {
      subtitle: t(`${translationBase}.lastModification.subtitle`),
      description: <Typography>{t(`${translationBase}.lastModification.description`)}</Typography>,
      imageLight: isPolish ? LIGHT_PL_1 : LIGHT_EN_1,
      imageDark: isPolish ? DARK_PL_1 : DARK_EN_1,
      key: 'carousel-schedule-info-history-1',
    },
  ]

  return <Carousel title={t(`${translationBase}.title`)} items={items} />
}

export default HistoryCarousel
